var WDN = WDN || {};

if (typeof WDN.CartCount === "undefined") {
  WDN.CartCount = (function () {
    var set, update;

    var set = function (newValue) {
      document
        .querySelectorAll("[data-cart-count]")
        .forEach(function (container) {
          container.setAttribute("data-cart-count", newValue);
          container.innerHTML = newValue;
        });
    };

    var update = function () {
      fetch(window.Shopify.routes.root + "cart.js")
        .then(response => response.json())
        .then(resJSON => set(resJSON.item_count));
    };

    return {
      set,
      update,
    };
  })();
}
